import Image from 'next/image'

interface PropsMarcas {
  src?: string[]
}
// Objeto de marcas con sus respectivas imágenes
export const srcMarcas: Record<string, string> = {
  bridgestone: 'bridgestone.webp',
  greentrac: 'greentrac.webp',
  michelin: 'michelin.webp',
  nexen: 'nexen.webp',
  triangle: 'triangle.webp',
  westlake: 'westlake.webp',
  lanvigator: 'lanvigator.webp',
  windforce: 'windforce.webp',
}

const Marcas = () => {
  return (
    <div className="flex flex-wrap justify-center gap-4 mt-4 mb-12">
      {Object.keys(srcMarcas).map((marca) => (
        <Image
          key={marca}
          width={173}
          height={90}
          quality={100}
          priority={true}
          src={`/marcas/${srcMarcas[marca]}`}
          alt={`Logo de ${marca}`}
        />
      ))}
    </div>
  )
}

export default Marcas
